var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close",attrs:{"aria-hidden":"true","href":"#","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-times"})])}]

export { render, staticRenderFns }